import React from "react";

const CustomerProtection = () => {

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight  uppercase tracking-tight">
              Customer Protection<span className="text-yellow-400">2023</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          
          </div>
        </div>
    </div>

      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="bg-black rounded-2xl p-1 shadow-xl overflow-hidden mb-8">
          <div className="bg-white rounded-xl overflow-hidden">
            <object width="100%" height="700" data="/file/CUSTOMER-PROTECTION-REGULATIONS-2023-1.pdf" type="application/pdf" className="w-full">
              <div className="p-10 text-center">
                <p className="text-base font-bold mb-4">PDF viewing not supported by your browser.</p>
                <a
                  href="/file/CUSTOMER-PROTECTION-REGULATIONS-2023-1.pdf"
                  download
                  className="bg-green-700 text-white px-8 py-3.5 rounded-xl font-bold uppercase tracking-wider text-xs inline-block shadow-lg hover:bg-black transition-all"
                >
                  Download PDF Instead
                </a>
              </div>
            </object>
          </div>
        </div>

        <div className="flex justify-center mt-8">
          <a
            href="/file/CUSTOMER-PROTECTION-REGULATIONS-2023-1.pdf"
            download
            className="group flex items-center gap-3 bg-yellow-400 text-black px-8 py-3.5 rounded-xl font-bold uppercase tracking-wider text-xs shadow-lg hover:bg-black hover:text-white transition-all transform hover:-translate-y-0.5"
          >
            <span className="bg-black text-white p-1.5 rounded-lg group-hover:bg-green-700 transition-colors">↓</span>
            Download Regulations Document
          </a>
        </div>
      </div>
    </div>
  );
};

export default CustomerProtection;
